import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { GoldContainer } from "./GoldContainer";
import { ShopCardContainer } from "./ShopCardContainer";

export class ShopScene extends Phaser.Scene {

    public static currentInstance: ShopScene;

    public static readonly DELTA_Y = 245;

    private scrollingContainer: Phaser.GameObjects.Container;
    private cardsContainer: ShopCardContainer[];
    private goldContainer: Phaser.GameObjects.Container;
    private onDownY: number;

    constructor() {

        super("ShopScene");
        
        ShopScene.currentInstance = this;
    }

    public create(): void {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        this.cardsContainer = [];
        this.onDownY = null;
 
        GameManager.setCurrentScene(this);

        if (!this.anims.exists("foil_fx")) {
            this.anims.create(
                {key: "foil_fx", 
                frames: this.anims.generateFrameNames("texture_atlas_2", {prefix: "foil_fx_", start: 1, end: 20, zeroPad: 2, suffix: ""}), 
                frameRate: 20, 
                repeat: -1
            });
        }

        const blackBackground = this.add.graphics();
        blackBackground.fillStyle(0x000000);
        blackBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.scrollingContainer = this.add.container(0, 0);
        this.scrollingContainer.scaleY = GameVars.scaleY;

        const mask = this.add.image(GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_1", "shop_mask");
        mask.setOrigin(.5, 0);
        mask.scaleY = GameVars.scaleY;

        const backButton = new Button(this, 55, 55 * GameVars.scaleY, "texture_atlas_1", "btn_close", "btn_close");
        backButton.scaleY = GameVars.scaleY;
        backButton.setInflationTween(1.1);
        backButton.onDown(this.onClickBack, this);
        this.add.existing(backButton);

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        const sectionTitleLabel = this.add.text(330, 45 * GameVars.scaleY, text.NEW_CARDS[lan], { fontFamily: "AlmendraBold", fontSize: "60px", color: "#000000" });
        sectionTitleLabel.setOrigin(.5);
        sectionTitleLabel.scaleY = GameVars.scaleY;
        sectionTitleLabel.setShadow(0, 8, "#7e4031", 0, false, true);
        sectionTitleLabel.setStroke("#3f2620", 8);
        this.add.existing(sectionTitleLabel);
         
        if (sectionTitleLabel.width > 450) {
            sectionTitleLabel.setScale(450 / sectionTitleLabel.width, 450 / sectionTitleLabel.width * GameVars.scaleY);
        }
       
        const gradient = sectionTitleLabel.context.createLinearGradient(0, 0, 0, sectionTitleLabel.height);
        gradient.addColorStop(0, "#fffea8");
        gradient.addColorStop(0.5, "#feec57");
        gradient.addColorStop(1, "#ef8548");
        sectionTitleLabel.setFill(gradient);

        this.goldContainer = new GoldContainer(this);
        this.add.existing(this.goldContainer);

        // ENCONTRAR EL INDICE DE LA ÚLTIMA CARTA DESBLOQUEADA
        const specialCards = GameVars.gameData.specialCards;

        let lastUnlockedCardIndex = 0;

        for (let i = 0; i < specialCards.length; i++) {

            if (!specialCards[i].unlocked) {
                lastUnlockedCardIndex = i;
                break;
            }
        }

        // SE HAN DESBLOQUADO TODAS LAS CARTAS?
        if (lastUnlockedCardIndex === 0) {
            this.scrollingContainer.y = -11 * ShopScene.DELTA_Y;
        } else {

            if (GameVars.specialCardJustUnlocked) {

                this.scrollingContainer.y = (-lastUnlockedCardIndex + 3) * ShopScene.DELTA_Y;
    
                this.tweens.add({
                    targets: this.scrollingContainer,
                    y: (-lastUnlockedCardIndex + 2) * ShopScene.DELTA_Y,
                    duration: 600,
                    ease: Phaser.Math.Easing.Cubic.Out,
                });
    
            } else {
    
                this.scrollingContainer.y = (-lastUnlockedCardIndex + 2) * ShopScene.DELTA_Y;
            }
        }

        for (let i = 0; i < 15; i++) {
            
            const specialCardData = specialCards[i];

            const shopCardContainer = new ShopCardContainer(this, specialCardData, i, lastUnlockedCardIndex);
            shopCardContainer.x = 225;
            shopCardContainer.y = i * ShopScene.DELTA_Y + 240;
            this.scrollingContainer.add(shopCardContainer);

            this.cardsContainer.push(shopCardContainer);
        }

        this.input.on("pointerdown", this.onPointerDown, this); 
        this.input.on("pointerup", this.onPointerUp, this);
    }

    public update(): void {

        if (this.onDownY !== null) {

            let y =  this.onDownY + this.input.y;

            const limit1 = 0;
            const limit2 = (-ShopScene.DELTA_Y * 14 + 600) * GameVars.scaleY;

            if (y > limit1)  {
                y = limit1;
            }
    
            if (y < limit2) {
                y = limit2;
            }
            
            this.scrollingContainer.y += (y - this.scrollingContainer.y) * .15;

            if (this.input.y >= GameConstants.GAME_HEIGHT - 5) {
                this.onDownY = null;
            }

            if (this.input.y <=  5) {
                this.onDownY = null;
            }
        }
    }

    private onPointerDown(pointer: Phaser.Input.Pointer): void {

        this.onDownY = this.scrollingContainer.y - pointer.y;
    }

    private onPointerUp(): void {

       this.onDownY = null;
    }

    private onClickBack(): void {
        
        GameManager.enterSplashScene(true);

        AudioManager.playSound("btn_click");
    }
}
